import { render, staticRenderFns } from "./SetPricing.vue?vue&type=template&id=14f81bc3&scoped=true&"
import script from "./SetPricing.vue?vue&type=script&lang=js&"
export * from "./SetPricing.vue?vue&type=script&lang=js&"
import style0 from "./SetPricing.vue?vue&type=style&index=0&id=14f81bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f81bc3",
  null
  
)

export default component.exports